import { AuthClientTokens } from './types'

let accessToken: string | null = null
let idToken: string | null = null
let refreshToken: string | null = null

export const tokenManager = {
  setTokens(tokens: AuthClientTokens) {
    accessToken = tokens.token ?? null
    idToken = tokens.idToken ?? null
    refreshToken = tokens.refreshToken ?? null
  },
  clearTokens() {
    accessToken = null
    idToken = null
    refreshToken = null
  },
  getAccessToken: () => accessToken,
  getIdToken: () => idToken,
  getRefreshToken: () => refreshToken,
  getTokens: () => ({
    token: accessToken,
    idToken,
    refreshToken,
  }),
} as const
